// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1229":"304f678f","5896":"5854b637","9213":"5854b637"}[chunkId] + ".chunk.css";
};